<section class="hero">
  <div>
    <p class="eyebrow">Intelligence</p>
    <h1>Recurring issues</h1>
  </div>
</section>

@if (data(); as result) {
  @if (result.items.length) {
    <section class="panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Patterns</p>
          <h2>{{ result.items.length }} recurring pattern{{ result.items.length === 1 ? '' : 's' }} detected</h2>
        </div>
      </div>

      <div class="issue-list">
        @for (issue of result.items; track issue.signature) {
          <div class="issue-card" [class.expanded]="isExpanded(issue.signature)">
            <button type="button" class="issue-header" (click)="toggleExpanded(issue.signature)">
              <div class="issue-header-left">
                <span class="sev-badge" [class]="severityClass(issue.severity)">{{ issue.severity }}</span>
                <span class="category-pill">{{ issue.category }}</span>
                <span class="issue-message">{{ issue.message }}</span>
              </div>
              <div class="issue-header-right">
                <span class="occurrence-badge">{{ issue.occurrenceCount }}×</span>
                <span class="expand-icon">{{ isExpanded(issue.signature) ? '▲' : '▼' }}</span>
              </div>
            </button>

            @if (isExpanded(issue.signature)) {
              <div class="issue-detail">
                <div class="detail-grid">
                  <div class="detail-block">
                    <p class="detail-label">Suggestion</p>
                    <p class="detail-value">{{ issue.suggestion }}</p>
                  </div>
                  <div class="detail-stats">
                    <div class="stat">
                      <span class="stat-value">{{ issue.occurrenceCount }}</span>
                      <span class="stat-label">Occurrences</span>
                    </div>
                    <div class="stat">
                      <span class="stat-value">{{ issue.repositoryCount }}</span>
                      <span class="stat-label">Repositories</span>
                    </div>
                    <div class="stat">
                      <span class="stat-value">{{ issue.developerCount }}</span>
                      <span class="stat-label">Developers</span>
                    </div>
                  </div>
                </div>

                @if (issue.topPaths.length) {
                  <div class="top-paths">
                    <p class="detail-label">Top affected paths</p>
                    <ul class="path-list">
                      @for (path of issue.topPaths; track path) {
                        <li>{{ path }}</li>
                      }
                    </ul>
                  </div>
                }

                <p class="last-seen">Last seen: {{ issue.latestSeenAt | localDate:'short' }}</p>
              </div>
            }
          </div>
        }
      </div>
    </section>
  } @else {
    <section class="state-card">
      <p>No recurring issues detected in the selected range. That's a good sign!</p>
    </section>
  }
} @else if (loading()) {
  <section class="state-card">Loading recurring issues…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="state-button" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No recurring issue data returned for the selected range.</p>
  </section>
}
